const phoneRegex = /^(?:\+|00)?\d{1,4}?[ \-()]*(?:\d[ \-()]*){6,14}\d$/;

export const isValidPhone = (phone: string): boolean => {
  return phoneRegex.test(phone);
}

export const isValidOptionalFax = (fax: string | null | undefined): boolean =>
  !fax || phoneRegex.test(fax)